<template>
  <div class="container-xxl">
    <titulo-grande texto="Usuários" posicao="left" />

    <modal tituloModal="Cadastro de usuário" textoBtnChamada="Inserir usuário" tamanho_modal="modal-lg">
      <template #default>
        <fieldset>
          <form @submit.prevent="cadastrar">
            <InputText placeholder="" label="Nome *" tamanho="sm" v-model="nome" />

            <InputTextMask placeholder="" nome="celular" label="Celular *" mask="cel" tamanho="sm" v-model="celular" />
            <InputText placeholder="" nome="email" tipo="email" label="Email *" mask="email" tamanho="sm"
              v-model="email" />

            <InputSelect name="acesso" ref="acesso" v-model="acesso" :dados="dados_acesso" label="Acesso *" />

            <InputText placeholder="" nome="cidade_votacao" label="Cidade onde vota *" tamanho="sm"
              v-model="cidade_votacao" />

            <InputText placeholder="" nome="codigo_multiplicador" tipo="codigo_multiplicador"
              label="Código do Eleitor Multiplicador" mask="codigo_multiplicador"
              tooltip="Código do Eleitor multiplicaador que indicou para o cadastro, caso não tenha deixar em branco."
              tamanho="sm" v-model="codigo_multiplicador" />

            <InputText placeholder="" nome="senha" tipo="password" :btn_lock="true" label="Senha *" tamanho="sm"
              v-model="senha" />
            <InputText placeholder="" nome="confirma_senha" tipo="password" :btn_lock="true" label="Confirme sua senha"
              tamanho="sm" v-model="confirma_senha" />
            <input type="submit" class="d-none" value="">
          </form>
        </fieldset>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="cadastrar" class="btn btn-primary">Cadastrar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :btnStatus="true" @edit_status="edit_status"
      :ativa_placeholder="ativa_placeholder">

    </TabelaDatatable>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue';
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import Modal from '@/components/Modal.vue';
import InputText from "@/components/form/InputText.vue";
import InputTextMask from "@/components/form/InputTextMask.vue";
import Spinner from "@/components/Spinner.vue";
import { api } from '@/services/api'
import { toastr } from '@/plugins/toast';
import InputSelect from '@/components/form/InputSelect.vue';
import { AuthStore } from '@/stores/Auth';
import { mensagem_request } from '@/assets/js/functions';

export default {
  name: 'ListaUsuarios',
  data() {
    return {
      auth: AuthStore(),
      dadosData: '',
      nome: '',
      celular: '',
      email: '',
      acesso: '',
      dados_acesso: [
        { valor: '', texto: 'Selecione um acesso' },
        { valor: '1', texto: 'Master' },
        { valor: '2', texto: 'Admin' },
      ],
      cidade_votacao: '',
      codigo_multiplicador: '',
      senha: '',
      confirma_senha: '',
      ativa_placeholder: Boolean,
    }
  },
  components: {
    TituloGrande,
    TabelaDatatable,
    Modal,
    InputText,
    InputTextMask,
    InputSelect,
    Spinner,
  },
  methods: {
    async listagemUsuarios() {
      this.ativa_placeholder = true
      this.dadosData = await api.get('user/lista_usuarios')
      this.ativa_placeholder = false
    },
    async edit_status(dados) {
      try {
        var sts = (dados.cellData == 'Ativo' ? 'Inativo' : 'Ativo')
        var cod = dados.rowData.id
        var autoriza = await api.autoriza();

        const stat = {
          status: sts,
          cod: cod,
          access: dados.rowData.acesso
        }

        if (autoriza) {
          try {
            const data = await api.post('user/altera_status', stat)

            var mgn = `Status de ${dados.rowData.nome} alterado para ${sts}`;

            if (sts == 'Ativo') {
              toastr.sucesso(mgn)
            } else {
              toastr.alerta(mgn)
            }
            this.listagemUsuarios()
          } catch (error) {
            toastr.erro(error)
          }
        } else {
          toastr.erro("É preciso estar logado como admin para esta ação.")
          this.$router.push('/login')
        }
      } catch (error) {
        toastr.erro("Erro na solicitação, tente novamente em alguns instantes.")
      }
    },
    async cadastrar(e) {
      e.preventDefault();

      if (!this.nome) {
        toastr.alerta("Digite seu nome")
        return false;
      }

      if (!this.celular) {
        toastr.alerta("Digite seu telefone")
        return false;
      }

      if (!this.email) {
        toastr.alerta("Digite seu Email")
        return false;
      }

      if (!this.acesso) {
        toastr.alerta("Selecione o acesso do usuário")
        document.querySelector("#acesso").focus()
        return false;
      }

      if (!this.cidade_votacao) {
        toastr.alerta("Digite a cidade em que vota")
        return false;
      }

      if (!this.senha) {
        toastr.alerta("Digite uma senha")
        return false;
      } else

        if (this.senha.length < 8) {
          toastr.alerta("A senha deve ter pelo menos 8 caracteres")
          return false;
        }

      if (this.senha != this.confirma_senha) {
        toastr.alerta("As senhas digitadas não conferem.")
        return false;
      }

      const dados = {
        nome: this.nome,
        celular: this.celular,
        email: this.email,
        acesso: this.acesso,
        cidade_votacao: this.cidade_votacao,
        codigo_multiplicador: this.codigo_multiplicador,
        senha: this.senha,
      };

      const campos = document.querySelector('fieldset')
      const loading = document.querySelector('#loading')
      campos.setAttribute('disabled', 'disabled')
      loading.classList.remove('d-none');
      try {
        const data = await api.post('user/register_admin', dados, { Authorization: this.auth.token })
        loading.classList.add('d-none');
        
        mensagem_request(data)

        if(data.status == 200){
          this.nome = '';
          this.celular = '';
          this.email = '';
          this.acesso = '';
          this.cidade_votacao = '';
          this.codigo_multiplicador = '';
          this.senha = '';
          this.confirma_senha = '';
  
          this.listagemUsuarios()
        }
      } catch (error) {
        toastr.erro("Erro ao cadastrar.");
      }
      loading.classList.add('d-none');
      campos.removeAttribute('disabled')

    },
  },
  mounted() {
    this.listagemUsuarios()
  },
}
</script>

<style></style>